module.exports = __webpack_public_path__ + "img/session3_3.4fa25b77.png";